const Registration = () => {
    return (
        <h1>y</h1>
    );
};

export default Registration;